var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-checkbox', {
    staticClass: "d-inline-block my-0 py-0 mr-n8",
    attrs: {
      "color": "primary",
      "hide-details": ""
    },
    on: {
      "change": _vm.emit
    },
    model: {
      value: _vm.isSelected,
      callback: function callback($$v) {
        _vm.isSelected = $$v;
      },
      expression: "isSelected"
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }